var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var CommissionStrategyService = /** @class */ (function (_super) {
    __extends(CommissionStrategyService, _super);
    function CommissionStrategyService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 委外佣金策略列表
     */
    CommissionStrategyService.prototype.getCommissionStrategyList = function (data, page) {
        return this.netService.send({
            server: domainService.commissionStrategyController.getCommissionStrategyList,
            data: data,
            page: page
        });
    };
    /**
     * 委外佣金策略删除
     */
    CommissionStrategyService.prototype.delCommissionStrategy = function (data) {
        return this.netService.send({
            server: domainService.commissionStrategyController.delCommissionStrategy,
            data: data,
            loading: true
        });
    };
    /**
     * 委外佣金策略详情
     */
    CommissionStrategyService.prototype.getCommissionDetailsById = function (data) {
        return this.netService.send({
            server: domainService.commissionStrategyController.getCommissionDetailsById,
            data: data
        });
    };
    /**
     * 委外佣金策略新增
     */
    CommissionStrategyService.prototype.insertCommissionStrategy = function (data) {
        return this.netService.send({
            server: domainService.commissionStrategyController.insertCommissionStrategy,
            data: data,
            loading: true
        });
    };
    /**
     * 委外佣金策略下拉列表
     */
    CommissionStrategyService.prototype.selectCommissionStrategyList = function () {
        return this.netService.send({
            server: domainService.commissionStrategyController.selectCommissionStrategyList
        });
    };
    /**
     * 委外佣金策略编辑
     */
    CommissionStrategyService.prototype.editCommissionStrategy = function (data) {
        return this.netService.send({
            server: domainService.commissionStrategyController.editCommissionStrategy,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], CommissionStrategyService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], CommissionStrategyService.prototype, "getCommissionStrategyList", null);
    return CommissionStrategyService;
}(Service));
export { CommissionStrategyService };
